module.exports = __webpack_public_path__ + "static/img/a2en.9b35f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a2en.png
// module id = jxnM
// module chunks = 0